import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StepFormData {
  [key: string]: any;
}

interface HouseRentState {
  applicationId: string | null;
  formData: {
    step1: StepFormData;
    step2: StepFormData;
    step3: StepFormData;
    step4: StepFormData;
  };
}

interface SaveFormDataPayload {
  applicationId: string;
  formData: StepFormData;
  step: 'step1' | 'step2' | 'step3' | 'step4';
}

const initialState: HouseRentState = {
  applicationId: null,
  formData: {
    step1: {},
    step2: {},
    step3: {},
    step4: {},
  },
};

export const houseRentSlice = createSlice({
  name: 'houseRent',
  initialState,
  reducers: {
    saveFormData: (state, action: PayloadAction<SaveFormDataPayload>) => {
      const { applicationId, formData, step } = action.payload;
      state.applicationId = applicationId;
      state.formData[step] = formData;
    },
    clearForm: (state) => {
      state.applicationId = null;
      state.formData = { step1: {}, step2: {}, step3: {}, step4: {} };
    },
  },
});

export const { saveFormData, clearForm } = houseRentSlice.actions;
export default houseRentSlice.reducer;
